const findElementById = (elements, id) => elements.find((element) => element.get('id') === id);
const getElementCellName = (elements, id) => findElementById(elements, id)?.get('cellName');
const forgeTransportName = (elements, sourceId, targetId) => {
  const transportSourceName = getElementCellName(elements, sourceId);
  const transportTargetName = getElementCellName(elements, targetId);
  return `T_${transportSourceName}_${transportTargetName}`;
};

// Call this function after a copy/paste operation to clear & rebuild the custom data stored in the Sorters (the list of
// ports contains the ids of the neighbor elements: these ids must be replaced by the ids of the newly created elements)
export const clearSorterDataOnCopy = (newElements) => {
  const links = [];
  const elements = [];
  newElements.forEach((cell) => {
    if (cell.isElement()) elements.push(cell);
    else links.push(cell);
  });

  const sorters = elements.filter((element) => element.get('type') === 'appShapes.Tri');
  const sorterIds = sorters.map((element) => element.get('id'));
  const portsDict = {};
  sorterIds.forEach((id) => {
    portsDict[id] = {};
  });

  links.forEach((link) => {
    const source = link.get('source');
    const target = link.get('target');

    if (sorterIds.includes(source.id)) {
      if (!source.port) {
        const linkId = link.get('id');
        console.warn(`Missing port in transport going out of sorter "${source.id}" (link id: "${linkId}")`);
      } else {
        portsDict[source.id][source.port] = portsDict[source.id][source.port] ?? {};
        portsDict[source.id][source.port].destination = target.id;
        portsDict[source.id][source.port].transportName = forgeTransportName(elements, source.id, target.id);
      }
    }

    if (sorterIds.includes(target.id)) {
      if (!target.port) {
        const linkId = link.get('id');
        console.warn(`Missing port in transport going to sorter "${target.id}" (link id: "${linkId}")`);
      } else {
        portsDict[target.id][target.port] = portsDict[target.id][target.port] ?? {};
        portsDict[target.id][target.port].source = source.id;
        portsDict[target.id][target.port].transportName = forgeTransportName(elements, source.id, target.id);
      }
    }
  });

  elements.forEach((element) => {
    if (element.get('type') !== 'appShapes.Tri') return;
    const elementId = element.get('id');
    const orderedTransportNodes = [];
    const ports = (element.get('ports') ?? {}).items;
    ports.forEach((port, portIndex) => {
      const preBuiltPortData = portsDict[elementId][port.id];
      orderedTransportNodes[portIndex] = preBuiltPortData?.transportName ?? '';
      port.source = preBuiltPortData?.source ?? null;
      port.destination = preBuiltPortData?.destination ?? null;
    });
    element.prop('orderedTransportNodes', orderedTransportNodes, { silent: true });
  });

  return { links, elements };
};
